export default __webpack_public_path__ + "static/media/brock_commons.176ba38b.png";